// Nearest-match human color naming for the client-facing report -- clients
// think in "Deep Ink Navy," not "#1B3A5C." A curated palette (not the full
// CSS-147 list) keeps this small while covering the hue/lightness range
// brand colors actually land in.
const NAMED_COLORS = [
  ['Black', '#0A0A0A'], ['Charcoal', '#2B2B2B'], ['Slate Grey', '#5A6472'],
  ['Warm Grey', '#8C8478'], ['Silver', '#C4C4C4'], ['Off White', '#F5F3EC'],
  ['White', '#FFFFFF'],
  ['Deep Ink Navy', '#1B3A5C'], ['Navy Blue', '#1E3A8A'], ['Royal Blue', '#2563EB'],
  ['Sky Blue', '#38BDF8'], ['Powder Blue', '#BFDBFE'], ['Teal', '#0D9488'],
  ['Turquoise', '#2DD4BF'], ['Deep Forest Green', '#14532D'], ['Forest Green', '#166534'],
  ['Emerald Green', '#10B981'], ['Sage Green', '#87A96B'], ['Lime Green', '#84CC16'],
  ['Olive', '#6B7A2C'], ['Mustard Yellow', '#D4A017'], ['Golden Yellow', '#EAB308'],
  ['Warm Brass', '#C5A059'], ['Amber', '#F59E0B'], ['Burnt Orange', '#C2570B'],
  ['Terracotta', '#C4643C'], ['Rust', '#9A3412'], ['Coral', '#FB7185'],
  ['Blush Pink', '#F4A6C1'], ['Hot Pink', '#EC4899'], ['Magenta', '#C026D3'],
  ['Plum', '#7C2D92'], ['Deep Purple', '#4C1D95'], ['Violet', '#7C3AED'],
  ['Lavender', '#C4B5FD'], ['Burgundy', '#7F1D1D'], ['Crimson Red', '#B91C1C'],
  ['Red', '#DC2626'], ['Brick Red', '#B03A2E'], ['Chocolate Brown', '#5C3A21'],
  ['Warm Tan', '#D2B48C'], ['Cream', '#F7F5EF'], ['Ivory', '#FFFFF0'],
];

const hexToRgb = (hex) => {
  const h = hex.replace('#', '').trim();
  const full = h.length === 3 ? h.split('').map((c) => c + c).join('') : h;
  const num = parseInt(full, 16);
  return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
};

export const nearestColorName = (hex) => {
  if (!hex) return '';
  let r, g, b;
  try {
    [r, g, b] = hexToRgb(hex);
    if ([r, g, b].some((v) => Number.isNaN(v))) return '';
  } catch {
    return '';
  }

  let best = null;
  let bestDist = Infinity;
  for (const [name, candidateHex] of NAMED_COLORS) {
    const [cr, cg, cb] = hexToRgb(candidateHex);
    const dist = (r - cr) ** 2 + (g - cg) ** 2 + (b - cb) ** 2;
    if (dist < bestDist) {
      bestDist = dist;
      best = name;
    }
  }
  return best || '';
};
